// Lazyweb serves public agent tools (search, ask, MCP) over our indexed pages.
// Its routes are forwarded under LAZYWEB_PREFIX on our own domain.
const LAZYWEB_SITE_ID = '17b1524a-8189-4d1e-bc9b-e535042f03f4';
const LAZYWEB_VERIFICATION_TOKEN = '090a68838452681409ae0285c86ceb110391c41cbc1be177';
const LAZYWEB_UPSTREAM_HOST = 'aced.thelazyweb.com';
const LAZYWEB_EVENTS_URL = `https://${LAZYWEB_UPSTREAM_HOST}/events`;
const LAZYWEB_LOADER_URL = 'https://app.thelazyweb.com/assets/lazyweb.js';
const LAZYWEB_ORIGIN = 'https://www.aced.io';
const LAZYWEB_PREFIX = '/agents';
const LAZYWEB_BASE_URL = `${LAZYWEB_ORIGIN}${LAZYWEB_PREFIX}`;
const LAZYWEB_AGENT_ACCESS_URL = `${LAZYWEB_BASE_URL}/agent-access`;
const LAZYWEB_FAQ_URL = `${LAZYWEB_BASE_URL}/agent/faq`;

// Signed-in, admin and per-user pages, which are never advertised to agents or recorded.
// `[id]` is the route pattern statically optimized pages render with before hydration.
const PRIVATE_PATH_PATTERNS = [
  /^\/(account|admin|analytics|certificates|chat|dashboard|home|invite|login|masterclass|onboarding|organization|precheckout|preview|refer|referrals|reset|signup|talent|users)(\/|$)/,
  /^\/coaching\/(book|booking|dashboard|session|submit)(\/|$)/,
  /^\/practice\/(ai|analytics|feedback|prepare|\[id\]|[0-9a-f]{8}-[0-9a-f-]{27})(\/|$)/,
  /^\/questions\/(add|edit)(\/|$)/,
  /^\/jobs\/referrals\/(admin|candidates|layoffs|referrer|requests?)(\/|$)/,
  /^\/(experiences\/admin|gift\/redeem|resume\/success|resume\/upload|upgrade\/success)(\/|$)/,
];

const isPrivatePath = (path) => PRIVATE_PATH_PATTERNS.some((pattern) => pattern.test(path));

const getLazywebLinks = (canonicalUrl) => [
  {rel: 'describedby', type: 'text/html', href: LAZYWEB_AGENT_ACCESS_URL},
  {rel: 'mcp', href: `${LAZYWEB_BASE_URL}/mcp/public`},
  {rel: 'alternate', type: 'text/markdown', href: `${LAZYWEB_BASE_URL}/page.md?url=${encodeURIComponent(canonicalUrl)}`},
];

module.exports = {
  LAZYWEB_SITE_ID,
  LAZYWEB_VERIFICATION_TOKEN,
  LAZYWEB_UPSTREAM_HOST,
  LAZYWEB_EVENTS_URL,
  LAZYWEB_LOADER_URL,
  LAZYWEB_ORIGIN,
  LAZYWEB_PREFIX,
  LAZYWEB_AGENT_ACCESS_URL,
  LAZYWEB_FAQ_URL,
  isPrivatePath,
  getLazywebLinks,
};
